/* Bijou Build Reviews Studio V2.1 – cached, prefetched Shopify review feeds (no iframe). */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.bbStudioReady === 'true') return;
    root.dataset.bbStudioReady = 'true';

    const $ = s => root.querySelector(s);
    const $$ = s => Array.from(root.querySelectorAll(s));
    const productButtons = $$('[data-bb-product]');
    const allButton = $('[data-bb-all]');
    const search = $('[data-bb-search]');
    const category = $('[data-bb-category]');
    const noMatch = $('[data-bb-no-match]');
    const mobileToggle = $('[data-bb-toggle-products]');
    const mobileClose = $('[data-bb-close-products]');
    const sidebar = $('[data-bb-sidebar]');
    const shortName = $('[data-bb-current-short]');
    const main = $('[data-bb-review-content]');
    const allIntro = $('[data-bb-all-intro]');
    const allResults = $('[data-bb-all-results]');
    const selected = $('[data-bb-selected]');
    const selectedImage = $('[data-bb-selected-image]');
    const selectedTitle = $('[data-bb-selected-title]');
    const selectedRating = $('[data-bb-selected-rating]');
    const selectedLink = $('[data-bb-selected-link]');
    const widgetTitle = $('[data-bb-widget-title]');
    const returnAll = $('[data-bb-return-all]');
    const loading = $('[data-bb-loading]');
    const dynamic = $('[data-bb-dynamic]');
    const error = $('[data-bb-error]');
    const errorLink = $('[data-bb-error-link]');
    const floating = $('[data-bb-floating]');
    const floatName = $('[data-bb-float-name]');
    const floatImage = $('[data-bb-float-image]');
    const floatPrice = $('[data-bb-float-price]');
    const floatCompare = $('[data-bb-float-compare]');
    const floatMessage = $('[data-bb-float-message]');
    const variantLabel = $('[data-bb-variant-label]');
    const variantSelect = $('[data-bb-variant]');
    const addButton = $('[data-bb-add]');
    const shopRoot = window.Shopify?.routes?.root || '/';
    const pagePath = window.location.pathname;
    const ignoredHandles = (root.dataset.blockedHandles || '')
      .split(/[\s,\n]+/).map(s => s.trim().toLowerCase()).filter(Boolean);

    let active = null;
    let activeData = null;
    let activeVariant = null;
    let pending = false;
    let seq = 0;
    let renderTimer = 0;
    // Store responses and already-rendered review DOM independently. A revisited
    // product should not repeat either the Shopify request or Judge.me boot.
    const reviewCache = new Map();
    const reviewRequests = new Map();
    const productCache = new Map();
    const productRequests = new Map();
    const mountedReviewCache = new Map();
    const MAX_HTML_CACHE = 12;
    const MAX_DOM_CACHE = 6;
    const CACHE_LIFETIME = 6 * 60 * 1000; // fresh reviews refresh in six minutes
    const previewThemeId = new URL(window.location.href).searchParams.get('preview_theme_id') || 'live';
    const cacheNamespace = 'bb-reviews-v2.1:' + previewThemeId + ':' +
      (window.Shopify?.locale || document.documentElement.lang || '') + ':' +
      (window.Shopify?.currency?.active || root.dataset.currency || '') + ':';
    const originalBodyPadding = document.body.style.paddingBottom;
    const originalBodyPaddingPx = parseFloat(getComputedStyle(document.body).paddingBottom) || 0;
    let stickyHeight = 0;

    /* Category list uses actual Shopify product types, never made-up classifications. */
    const names = new Set(productButtons.map(b => b.dataset.type).filter(Boolean));
    if (names.size > 1) {
      [...names].sort((a,b) => a.localeCompare(b)).forEach(n => {
        const opt = document.createElement('option');
        opt.value = n;
        opt.textContent = n;
        category.append(opt);
      });
    } else {
      category.parentElement.hidden = true;
    }

    function filterList() {
      const q = search.value.trim().toLocaleLowerCase();
      const type = category.value;
      let count = 0;
      productButtons.forEach(b => {
        const matches = (!q || b.dataset.title.toLocaleLowerCase().includes(q)) &&
          (type === 'all' || b.dataset.type === type);
        b.hidden = !matches;
        if (matches) count++;
      });
      allButton.hidden = Boolean(q) || type !== 'all';
      noMatch.hidden = count > 0;
    }
    search.addEventListener('input',filterList);
    category.addEventListener('change',filterList);

    function toggleSidebar(open) {
      const value = Boolean(open);
      sidebar.classList.toggle('is-open', value);
      mobileToggle.setAttribute('aria-expanded',String(value));
      $('.bb-reviews__mobile-toggle').textContent = value ? '−' : '+';
    }
    mobileToggle.addEventListener('click',() => toggleSidebar(!sidebar.classList.contains('is-open')));
    mobileClose.addEventListener('click',() => toggleSidebar(false));

    function updateUrl(handle, method='pushState') {
      const u = new URL(window.location.href);
      if (handle) u.searchParams.set('review_product',handle);
      else u.searchParams.delete('review_product');
      if (u.href !== window.location.href) window.history[method](null,'',u);
    }

    function setActiveButton(button) {
      productButtons.forEach(b => {
        b.classList.toggle('is-active',b === button);
        b.setAttribute('aria-current',b === button ? 'true':'false');
      });
      allButton.classList.toggle('is-active', !button);
      allButton.setAttribute('aria-current',String(!button));
    }

    // Never abort an in-flight response on product change: a completed request
    // can be reused if the visitor immediately switches back to that product.
    // seq still protects the active panel from stale responses.
    function clearRequest() {
      seq++;
      clearTimeout(renderTimer);
    }

    function limitMap(map, maximum) {
      while (map.size > maximum) map.delete(map.keys().next().value);
    }

    function readStoredReviews(handle) {
      try {
        const raw = sessionStorage.getItem(cacheNamespace + handle);
        if (!raw) return null;
        const record = JSON.parse(raw);
        if (!record || Date.now() - record.time > CACHE_LIFETIME || typeof record.html !== 'string') {
          sessionStorage.removeItem(cacheNamespace + handle);
          return null;
        }
        return record.html;
      } catch (_) { return null; }
    }

    function cacheReviewHtml(handle, html) {
      // Do not persist huge legacy widgets, which can exceed browser storage quotas.
      reviewCache.set(handle, html);
      limitMap(reviewCache, MAX_HTML_CACHE);
      if (html.length > 180000) return;
      try {
        sessionStorage.setItem(cacheNamespace + handle,
          JSON.stringify({time: Date.now(), html}));
      } catch (_) { /* private browsing / full storage: in-memory cache still works */ }
    }

    function loadReviewHtml(button) {
      const handle = button.dataset.handle;
      if (reviewCache.has(handle)) return Promise.resolve(reviewCache.get(handle));
      const stored = readStoredReviews(handle);
      if (stored) {
        reviewCache.set(handle, stored);
        limitMap(reviewCache, MAX_HTML_CACHE);
        return Promise.resolve(stored);
      }
      if (reviewRequests.has(handle)) return reviewRequests.get(handle);
      const u = new URL(button.dataset.url, window.location.origin);
      u.searchParams.set('section_id', root.dataset.reviewSection);
      const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
      if (preview) u.searchParams.set('preview_theme_id', preview);
      const request = fetch(u.toString(), {
        credentials: 'same-origin', headers: {Accept: 'text/html'}
      }).then(response => {
        if (!response.ok) throw new Error('Review section request failed: ' + response.status);
        return response.text();
      }).then(html => {
        if (!html || !html.includes('data-bb-product-review-feed')) {
          throw new Error('Review section not returned');
        }
        cacheReviewHtml(handle, html);
        return html;
      }).finally(() => reviewRequests.delete(handle));
      reviewRequests.set(handle, request);
      return request;
    }

    function loadProductJson(button) {
      const handle = button.dataset.handle;
      if (productCache.has(handle)) return Promise.resolve(productCache.get(handle));
      if (productRequests.has(handle)) return productRequests.get(handle);
      const url = new URL(button.dataset.url, window.location.origin);
      url.pathname = url.pathname.replace(/\/$/, '') + '.js';
      url.search = '';
      const request = fetch(url.toString(), {
        credentials: 'same-origin', headers: {Accept: 'application/json'}
      }).then(res => {
        if (!res.ok) throw new Error('Failed to load product options');
        return res.json();
      }).then(data => {
        productCache.set(handle, data);
        limitMap(productCache, 30);
        return data;
      }).finally(() => productRequests.delete(handle));
      productRequests.set(handle, request);
      return request;
    }

    function rememberReviewPanel() {
      if (!active) return;
      const feed = dynamic.querySelector('[data-bb-product-review-feed]');
      // Only retain fully rendered widgets. Unfinished ones should reinitialize.
      const widget = feed?.querySelector('.jdgm-review-widget');
      const fallback = feed?.querySelector('.bb-reviews__legacy-fallback');
      if (feed && (hasRenderedReviews(widget) || fallback)) {
        mountedReviewCache.delete(active.dataset.handle);
        mountedReviewCache.set(active.dataset.handle, feed);
        limitMap(mountedReviewCache, MAX_DOM_CACHE);
      }
    }

    function restoreView() {
      rememberReviewPanel();
      clearRequest();
      active = activeData = activeVariant = null;
      setActiveButton(null);
      shortName.textContent = 'All reviews';
      allIntro.hidden = false;
      allResults.hidden = false;
      selected.hidden = true;
      dynamic.replaceChildren();
      loading.hidden = true;
      error.hidden = true;
      floating.classList.remove('is-visible');
      floating.setAttribute('aria-hidden','true');
      resetBodyPadding();
      toggleSidebar(false);
    }

    function scrollToContent() {
      const target = main.getBoundingClientRect().top + window.scrollY -
        (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--bb-header-height'),10) || 110) - 12;
      window.scrollTo({top:Math.max(0,target),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
    }

    function allReviews({scroll = true, updateUrl = true} = {}) {
      restoreView();
      if (updateUrl) updateUrlFor(null);
      if (scroll) scrollToContent();
    }
    function updateUrlFor(handle) { updateUrl(handle); }

    function money(cents) {
      const iso = window.Shopify?.currency?.active || root.dataset.currency || 'USD';
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US',
          {style:'currency',currency:iso}).format(Number(cents)/100);
      } catch(e) { return active?.dataset.price || ''; }
    }

    function isComplex() {
      const optionNames = (activeData?.options || []).map(o =>
        typeof o === 'string' ? o : o?.name || '');
      const hasSpecialOption = optionNames.some(name => /wood|add.?on|bundle/i.test(name));
      return Boolean(active && ignoredHandles.includes(active.dataset.handle.toLowerCase())) ||
        Boolean(activeData && (activeData.requires_selling_plan || hasSpecialOption));
    }

    function updatePurchase() {
      if (!active) return;
      const complex = isComplex();
      if (complex) {
        variantLabel.hidden = true;
        addButton.disabled = false;
        addButton.textContent = 'Choose options';
        floatMessage.textContent = 'Configure on the product page';
        return;
      }
      const hasVariants = activeData && activeData.variants && activeData.variants.length > 1;
      variantLabel.hidden = !hasVariants;
      if (!activeVariant) {
        addButton.textContent = 'Loading…';
        addButton.disabled = true;
        return;
      }
      const available = Boolean(activeVariant.available);
      addButton.textContent = available ? 'Add to Cart' : 'Sold Out';
      addButton.disabled = !available || pending;
      floatPrice.textContent = money(activeVariant.price);
      const compare = activeVariant.compare_at_price;
      floatCompare.hidden = !(compare > activeVariant.price);
      floatCompare.textContent = compare > activeVariant.price ? money(compare) : '';
      floatMessage.textContent = available ? '' : 'Currently unavailable';
      if (activeVariant.featured_image?.src) {
        floatImage.src = activeVariant.featured_image.src;
      }
    }

    function preparePurchase(button) {
      activeData = activeVariant = null;
      floatName.textContent = button.dataset.title;
      floatPrice.textContent = button.dataset.price;
      floatCompare.hidden = true;
      floatMessage.textContent = '';
      floatImage.hidden = !button.dataset.image;
      if (button.dataset.image) floatImage.src = button.dataset.image;
      variantLabel.hidden = true;
      addButton.textContent = 'Loading…';
      addButton.disabled = true;
    }

    async function fetchProductData(button, id) {
      try {
        const data = await loadProductJson(button);
        if (id !== seq) return;
        activeData = data;
        variantSelect.replaceChildren();
        (data.variants || []).forEach(v => {
          const option = document.createElement('option');
          option.value = String(v.id);
          option.textContent = (v.public_title || v.title || 'Default').replace(/Default Title/i, 'Standard') + (v.available ? '' : ' — Sold out');
          option.disabled = !v.available;
          variantSelect.append(option);
        });
        activeVariant = data.variants.find(v => v.available) || data.variants[0] || null;
        if (activeVariant) variantSelect.value = String(activeVariant.id);
        updatePurchase();
      } catch (e) {
        if (id !== seq) return;
        addButton.disabled = false;
        addButton.textContent = 'View product';
        floatMessage.textContent = 'Options available on product page';
        activeData = null;
      }
    }

    variantSelect.addEventListener('change',()=>{
      if (!activeData) return;
      activeVariant = activeData.variants.find(v=>String(v.id)===String(variantSelect.value)) || null;
      updatePurchase();
    });

    function showError() {
      loading.hidden = true;
      error.hidden = false;
      dynamic.replaceChildren();
      if (active) errorLink.href = active.dataset.url + '#judgeme_product_reviews';
    }

    function hasRenderedReviews(widget) {
      if (!widget) return false;
      return [...widget.querySelectorAll('.jdgm-rev-widg, .jdgm-rev, .jdgm-rev-widg__header, .jdgm-review-widget__reviews')]
        .some(el => !el.closest('.jdgm-legacy-widget-content'));
    }

    function installJudgeMeData(fragment) {
      const node = fragment.querySelector('[data-bb-product-review-feed]');
      const payload = node?.querySelector('[data-bb-review-json]');
      if (payload && node) {
        try {
          window.jdgm = window.jdgm || {};
          window.jdgm.data = window.jdgm.data || {};
          window.jdgm.data.reviewWidget = window.jdgm.data.reviewWidget || {};
          window.jdgm.data.reviewWidget[node.dataset.productId] = JSON.parse(payload.textContent);
        } catch (e) {
          // Legacy HTML fallback is still supplied below for affected installations.
        }
      }
      const widget = dynamic.querySelector('.jdgm-review-widget');
      // Judge.me variants expose different public methods. Use those that exist;
      // native widget remains responsible for sorting, pagination and photos.
      for (const method of ['loadWidgets','renderWidgets']) {
        if (typeof window.jdgm?.[method] === 'function') {
          try { window.jdgm[method](); } catch (_) {}
          break;
        }
      }
      // If an older storefront's app script does not discover AJAX-inserted
      // widgets, display the pre-rendered LEGACY HTML instead of a blank pane.
      renderTimer = window.setTimeout(() => {
        if (!active || !dynamic.contains(widget) || hasRenderedReviews(widget)) return;
        const legacy = widget?.querySelector('.jdgm-legacy-widget-content');
        if (legacy && legacy.innerHTML.trim().length > 100) {
          const fallback = document.createElement('div');
          fallback.className = 'bb-reviews__legacy-fallback';
          fallback.innerHTML = legacy.innerHTML;
          widget.replaceWith(fallback);
        } else {
          showError();
        }
      }, 4500);
    }

    async function fetchReviews(button, id) {
      try {
        const html = await loadReviewHtml(button);
        if (id !== seq) return;
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const feed = parsed.querySelector('[data-bb-product-review-feed]');
        if (!feed) throw new Error('Reviews missing from response');
        dynamic.replaceChildren(document.importNode(feed, true));
        loading.hidden = true;
        installJudgeMeData(parsed);
      } catch (e) {
        if (id !== seq) return;
        showError();
      }
    }

    function chooseProduct(button, {scroll=true,updateUrl=true} = {}) {
      if (!button) return;
      rememberReviewPanel();
      clearRequest();
      const id = seq;
      active = button;
      setActiveButton(button);
      shortName.textContent = button.dataset.title;
      toggleSidebar(false);
      allIntro.hidden = true;
      allResults.hidden = true;
      selected.hidden = false;
      error.hidden = true;
      const cachedPanel = mountedReviewCache.get(button.dataset.handle);
      loading.hidden = Boolean(cachedPanel);
      dynamic.replaceChildren();
      if (cachedPanel) dynamic.appendChild(cachedPanel);
      selectedTitle.textContent = button.dataset.title;
      selectedImage.hidden = !button.dataset.image;
      if (button.dataset.image) selectedImage.src = button.dataset.image;
      selectedImage.alt = button.dataset.title;
      const count = Number(button.dataset.count);
      const rate = Number(button.dataset.rating);
      selectedRating.replaceChildren();
      if (count>0 && rate>0) {
        const stars = document.createElement('span');
        stars.className='bb-reviews__stars';
        stars.setAttribute('aria-hidden','true');
        stars.textContent='★';
        selectedRating.append(stars,document.createTextNode('  '+rate.toFixed(1)+' out of 5 · '+count+' reviews'));
      } else selectedRating.textContent='Explore customer reviews';
      selectedLink.href = button.dataset.url;
      widgetTitle.textContent = button.dataset.title + ' reviews';
      errorLink.href = button.dataset.url + '#judgeme_product_reviews';
      preparePurchase(button);
      if (updateUrl) updateUrlFor(button.dataset.handle);
      if (scroll) scrollToContent();
      fetchProductData(button, id);
      if (!cachedPanel) fetchReviews(button, id);
      scheduleSticky();
    }

    function resetBodyPadding() {
      if (stickyHeight) {document.body.style.paddingBottom = originalBodyPadding;stickyHeight = 0;}
    }
    function scheduleSticky() {
      const shouldShow = Boolean(active) && !selected.hidden &&
        selected.querySelector('.bb-reviews__selected-card').getBoundingClientRect().bottom < 0;
      floating.classList.toggle('is-visible',shouldShow);
      floating.setAttribute('aria-hidden',String(!shouldShow));
      if (shouldShow) {
        const px = Math.ceil(floating.offsetHeight);
        if (px !== stickyHeight) {
          stickyHeight = px;
          document.body.style.paddingBottom = (originalBodyPaddingPx + px) + 'px';
        }
      } else resetBodyPadding();
    }
    window.addEventListener('scroll',scheduleSticky,{passive:true});
    window.addEventListener('resize',scheduleSticky,{passive:true});

    // Predictive prefetch: hovering/focusing starts the same request a click
    // would make. The in-flight promise is shared, not fetched twice.
    function warmProduct(button, includeProduct = true) {
      if (!button) return Promise.resolve();
      const jobs = [loadReviewHtml(button).catch(() => null)];
      if (includeProduct) jobs.push(loadProductJson(button).catch(() => null));
      return Promise.all(jobs);
    }
    productButtons.forEach(button => {
      button.addEventListener('pointerenter', () => warmProduct(button));
      button.addEventListener('focus', () => warmProduct(button));
      button.addEventListener('touchstart', () => warmProduct(button), {passive: true});
      button.addEventListener('click', () => chooseProduct(button));
    });

    // Background warm-up: first two listed products plus three frequently
    // reviewed products. Cap concurrency at 2 and respect data-saver.
    function warmInitialProducts() {
      const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      if (connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType || '')) return;
      const reviewed = productButtons.filter(button => Number(button.dataset.count) > 0);
      const popular = [...reviewed].sort((a, b) => Number(b.dataset.count) - Number(a.dataset.count));
      const candidates = [...new Set([...reviewed.slice(0, 2), ...popular])].slice(0, 5);
      let cursor = 0;
      const worker = async () => {
        while (cursor < candidates.length) {
          const index = cursor++;
          await warmProduct(candidates[index], index < 2);
        }
      };
      void worker();
      void worker();
    }
    if (typeof requestIdleCallback === 'function') {
      requestIdleCallback(warmInitialProducts, {timeout: 900});
    } else {
      setTimeout(warmInitialProducts, 350);
    }
    allButton.addEventListener('click',()=>allReviews());
    returnAll.addEventListener('click',()=>allReviews());

    addButton.addEventListener('click',async()=>{
      if (!active || pending) return;
      if (!activeData || isComplex()) {
        window.location.assign(active.dataset.url);
        return;
      }
      if (!activeVariant?.available) return;
      pending = true;
      addButton.disabled = true;
      addButton.textContent = 'Adding…';
      floatMessage.textContent = 'Adding to cart';
      try {
        const res = await fetch(shopRoot + 'cart/add.js',{
          method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},
          body:JSON.stringify({items:[{id:activeVariant.id,quantity:1}]})
        });
        if (!res.ok) {
          const body = await res.json().catch(()=>({}));
          throw new Error(body.description || body.message || 'Unable to add this product');
        }
        floatMessage.textContent = 'Added to your cart';
        if (root.dataset.cartMode === 'cart') window.location.assign(shopRoot+'cart');
        else {pending=false;addButton.textContent='Added to Cart';addButton.disabled=false;}
      } catch(e) {
        pending=false;
        floatMessage.textContent=e.message || 'Could not add product';
        updatePurchase();
      }
    });

    window.addEventListener('popstate',()=>{
      const handle = new URL(window.location.href).searchParams.get('review_product');
      const button = productButtons.find(b=>b.dataset.handle===handle);
      if (button) chooseProduct(button,{scroll:false,updateUrl:false});
      else allReviews({scroll:false,updateUrl:false});
    });
    const initial = new URL(window.location.href).searchParams.get('review_product');
    const button = productButtons.find(b=>b.dataset.handle===initial);
    if (button) chooseProduct(button,{scroll:false,updateUrl:false});
    else allReviews({scroll:false,updateUrl:false});
    filterList();
  }

  function boot(context = document) {
    context.querySelectorAll('[data-bb-reviews]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>boot());
  else boot();
  document.addEventListener('shopify:section:load',event=>boot(event.target));
})();
